module.exports = __webpack_public_path__ + "img/about6.5ccb2b00.png";